import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  usePracticeTableStore,
  initialPracticeColumns,
} from 'views/pages/Admin/Practice/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type PracticeColumnKey =
  'name' | 'partner_name' | 'city' | 'county' | 'phone_number';

const PRACTICE_TABLE_COLUMN_LABELS: Record<PracticeColumnKey, string> = {
  name: 'Name',
  partner_name: 'Partner',
  city: 'City / State',
  county: 'County',
  phone_number: 'Phone',
};

const ALL_FIELDS = initialPracticeColumns.map(
  c => c.field,
) as PracticeColumnKey[];

export const PracticeTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = usePracticeTableStore(s => s.hiddenColumns);
  const setHiddenColumns = usePracticeTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<PracticeColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<PracticeColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='practice_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={PRACTICE_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
